import { handleActions } from 'redux-actions';
import { Article } from '@models/Article';
import { articlesSet } from './action';

export interface State {
  articles?: Article[];
}

const initialState: State = {};

const reducer = handleActions(
  {
    [String(articlesSet)]: (state, { payload }) => {
      return {
        ...state,
        articles: payload.articles,
      };
    },
  },

  initialState,
);

export default reducer;
